React = require 'react'
t = require('views/internal/recup-with-helpers')()

module.exports = class extends React.Component
  displayName: 'HelpOverlay'

  componentDidMount: ->
    window.addEventListener 'message', @receiveMessage.bind(@)

  componentWillUnmount: ->
    window.removeEventListener 'message', @receiveMessage.bind(@)

  receiveMessage: (e) ->
    if e.source == @refs.iframe.contentWindow
      { type, value } = e.data
      switch type
        when 'resize'
          # We don't actually want to trigger a re-render, because that'll
          # make the iframe reload
          @refs.loading.style.display = 'none'
          currentHeight = parseFloat(@refs.iframe.style.height)
          # The scrollbar from the page causes issues when changing height. Don't change the height
          # unless it's getting larger or the values are significantly different
          if !@refs.iframe.style.height || (currentHeight < value && currentHeight - value < 50)
            @refs.iframe.style.height = value + 'px'

  render: t.renderable ->
    t.div ->
      t.div '.spinner.loading',
        ref: 'loading'

      t.iframe '.help-embedded-iframe',
        ref: 'iframe'
        src: "/contact?compact=1&trello=1&url=#{ encodeURIComponent(location.href) }&source=from%20in%20app"



// WEBPACK FOOTER //
// ./app/scripts/views/header/help-component.coffee